import { buildNavigationUrl } from "../../util/buildNavigationUrl";
const buildJobNavigationTargetUrl = ({
  activeSubPage = "details",
  listContext = {},
  recordId,
  status = "all",
}) => {
  const query = new URLSearchParams(
    status && status !== "all" ? { status } : {},
  );

  ["listId", "workingListId"].forEach(key => {
    const value = listContext[key];
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, value);
    }
  });

  return buildNavigationUrl(
    `/jobs/${recordId}/${activeSubPage || "details"}`,
    query,
  );
};

export { buildJobNavigationTargetUrl };
